<template>

  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center">
        <v-data-table :headers="headers" :items="ensayo.detail" :items-per-page="30" hide-default-footer>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Parámetros del ensayo</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn 
              top
              right
              class="ma-2" 
              color="primary"
              to="/ensayos" 
              dark>
                <v-icon dark left>mdi-arrow-left</v-icon>Lista de ensayos
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:item.value="{ item }">
            <span v-if="item.isEditing===false">{{item.value}}</span>
            <v-container v-else>
              <v-select
                v-if="item.format==='-'"
                v-model="item.value"
                :items="items"
                class="pa-0 short-dd"
                hide-details 
                single-line
                dense
              ></v-select>
              <v-text-field v-else v-model="item.value" class="short-tf" hide-details single-line dense></v-text-field>
            </v-container>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" v-if="item.isEditing===false" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-container v-else>
              <v-icon small class="mr-2" @click="save(item)">mdi-check</v-icon>
              <v-icon small class="mr-2" @click="cancel(item)">mdi-close</v-icon>
            </v-container>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col class="text-center">
        <clavelist></clavelist>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col class="text-center">
        <mensajelist></mensajelist>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ClaveList from './ClaveList.vue'
  import MensajeList from './MensajeList.vue'

  export default {
    data: () => ({
      dialog: false,
      items: [false, true],
      headers: [
        { text: 'Nombre', align: 'start', sortable: true, value: 'name',},
        { text: 'Valor', value: 'value', sortable: false, align: 'left'  },
        { text: 'Unidad', value: 'format', sortable: false, align: 'middle' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'middle' },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    computed: {
      ensayo() {
        return this.$store.state.ensayo
      },
      categorias() {
        return this.$store.state.categorias
      },
      usuario() {
        return this.$store.state.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize(),
      this.$store.dispatch('loadEnsayoDetail', {
        id: this.$route.params.id
      }),
      this.$store.dispatch('loadCategorias')
    },

    methods: {
      initialize () {
        this.desserts = [
          {
            id: 1,
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
          },
          {
            id: 2,
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
          },
        ]
      },

      editItem (item) {
        var editedIndex = this.ensayo.detail.indexOf(item)
        item = Object.assign({}, item)
        item.isEditing = true;
        item.preValue = item.value;
        Object.assign(this.ensayo.detail[editedIndex], item)
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      save (item) {
        item.isEditing = false;
        var editedIndex = this.ensayo.detail.indexOf(item)
        Object.assign(this.ensayo.detail[editedIndex], item)
        this.ensayo[item['alias']] = item['value'];
        if (!this.ensayo.detail.some(element => element.isEditing === true)) {
          this.$store.dispatch('editEnsayo', {
            'id': this.ensayo.id, 
            'item': this.ensayo
          });
        }
      },

      cancel (item) {
        item.isEditing = false;
        item.value = item.preValue;
        var editedIndex = this.ensayo.detail.indexOf(item)
        Object.assign(this.ensayo.detail[editedIndex], item)
      }
    },
    components: {
      clavelist: ClaveList,
      mensajelist: MensajeList
    }
  }
</script>

<style scoped>
  .short-tf {
    width: 50px;
  }
  .short-dd {
    width: 70px;
  }
</style>
